"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Desio certificazione contatti
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.LogCertificazioneInfoCenterDtoToJSON = exports.LogCertificazioneInfoCenterDtoFromJSONTyped = exports.LogCertificazioneInfoCenterDtoFromJSON = void 0;
const runtime_1 = require("../runtime");
function LogCertificazioneInfoCenterDtoFromJSON(json) {
    return LogCertificazioneInfoCenterDtoFromJSONTyped(json, false);
}
exports.LogCertificazioneInfoCenterDtoFromJSON = LogCertificazioneInfoCenterDtoFromJSON;
function LogCertificazioneInfoCenterDtoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !runtime_1.exists(json, 'id') ? undefined : json['id'],
        'idLogTracciatoInfoCenterSource': !runtime_1.exists(json, 'idLogTracciatoInfoCenterSource') ? undefined : json['idLogTracciatoInfoCenterSource'],
        'idLogTracciatoInfoCenterTarget': !runtime_1.exists(json, 'idLogTracciatoInfoCenterTarget') ? undefined : json['idLogTracciatoInfoCenterTarget'],
        'logOutput': !runtime_1.exists(json, 'logOutput') ? undefined : json['logOutput'],
        'exceptionLogOutput': !runtime_1.exists(json, 'exceptionLogOutput') ? undefined : json['exceptionLogOutput'],
        'dataEstrazione': !runtime_1.exists(json, 'dataEstrazione') ? undefined : (new Date(json['dataEstrazione'])),
        'dataFineEstrazione': !runtime_1.exists(json, 'dataFineEstrazione') ? undefined : (json['dataFineEstrazione'] === null ? null : new Date(json['dataFineEstrazione'])),
    };
}
exports.LogCertificazioneInfoCenterDtoFromJSONTyped = LogCertificazioneInfoCenterDtoFromJSONTyped;
function LogCertificazioneInfoCenterDtoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'idLogTracciatoInfoCenterSource': value.idLogTracciatoInfoCenterSource,
        'idLogTracciatoInfoCenterTarget': value.idLogTracciatoInfoCenterTarget,
        'logOutput': value.logOutput,
        'exceptionLogOutput': value.exceptionLogOutput,
        'dataEstrazione': value.dataEstrazione === undefined ? undefined : (value.dataEstrazione.toISOString()),
        'dataFineEstrazione': value.dataFineEstrazione === undefined ? undefined : (value.dataFineEstrazione === null ? null : value.dataFineEstrazione.toISOString()),
    };
}
exports.LogCertificazioneInfoCenterDtoToJSON = LogCertificazioneInfoCenterDtoToJSON;
